module.exports = __webpack_public_path__ + "assets/img/37_1485_big.ad2e9764.jpg";